import { connect } from 'react-redux';
import { MarketingHomeComponent } from '../../components';

const mapStateToProps = state => ({
  user: state.auth.user
})

const mapDispatchToProps = { };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketingHomeComponent)



// WEBPACK FOOTER //
// ./src/containers/Marketing/Home.js